module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-yen-066f9e2a.svg";